import React from "react";
import "./Bets.css"
import Common from "./Common";
import ProvablyFair from "./windows/ProvablyFair";
import CheckFairness from "./windows/CheckFairness";
import { EVENTS } from "./core/EVENTS";
import { Controller } from "./core/Controller";
import { Comm } from "./core/comm/Comm";


export default class Bets extends React.Component<Bets.Props, Bets.State>
{

    leaderboardTypesMap: Array<Comm.LeaderboardType> = ["huge_wins", "biggest_wins", "multipliers"];
    leaderboardPeriodsMap: Array<Comm.LeaderboardPeriod> = ["day", "month", "year"];

    refList: React.RefObject<HTMLDivElement>;

    constructor(props: Bets.Props)
    {
        super(props);

        this.updateBetsListHeightAndPad = this.updateBetsListHeightAndPad.bind(this);
        
        this.refList = React.createRef();

        this.state = {
            menuIndex: 0,
            winsIndex: 0,
            timeIndex: 0,
            previousMultiplier: null,
            data: null,
            bet_count: 0,
            previous: false,
            itemsPad: 0,
            itemsShown: 0
        };
    }


    checkFairness(id: string)
    {
        if (id != Controller.gameRoundId)
        {
            app.addWindow(<CheckFairness
                roundId={id}
            />);
        }
    }


    componentDidMount()
    {
        EVENTS.on(EVENTS.RESPONSE.MY_BETS_UPDATE, this.onMyBetsUpdated, this);
        EVENTS.on(EVENTS.RESPONSE.ALL_BETS_UPDATE, this.onAllBetsUpdated, this);

        Comm.on(Comm.RESPONSE.LEADERBOARD, this.onLeaderBoardsUpdate, this);
        Comm.on(Comm.RESPONSE.PREVIOUS_BETS, this.onPreviousBetsResponse, this);

        window.addEventListener("resize", this.updateBetsListHeightAndPad);
    }
    
    
    componentWillUnmount()
    {
        EVENTS.off(EVENTS.RESPONSE.MY_BETS_UPDATE, this.onMyBetsUpdated, this);
        EVENTS.off(EVENTS.RESPONSE.ALL_BETS_UPDATE, this.onAllBetsUpdated, this);
        
        Comm.off(Comm.RESPONSE.LEADERBOARD, this.onLeaderBoardsUpdate, this);
        Comm.off(Comm.RESPONSE.PREVIOUS_BETS, this.onPreviousBetsResponse, this);
        
        window.removeEventListener("resize", this.updateBetsListHeightAndPad);
    }


    componentDidUpdate()
    {
        this.updateBetsListHeightAndPad();
    }


    onAllBetsUpdated(data: Array<Comm.ResponseTypes.BetData>)
    {
        if (this.state.menuIndex == 0 && !this.state.previous)
        {
            this.setState({
                data: data,
                bet_count: Controller.all_bets_count,
                ...this.getBetsListHeightAndPad(data)
            });
        }
    }


    onMyBetsUpdated(data: Array<Comm.ResponseTypes.BetData>)
    {
        if (this.state.menuIndex == 1)
        {
            this.setState({
                data: data
            });
        }
    }


    onLeaderBoardsUpdate(data: Comm.ResponseTypes.Leaderboard)
    {
        const sameMenu = this.state.menuIndex == 2;
        const sameType = data.type == this.leaderboardTypesMap[this.state.winsIndex];
        const samePeriod = data.period == this.leaderboardPeriodsMap[this.state.timeIndex];

        if (sameMenu && sameType && samePeriod)
        {
            this.setState({
                data: data.data
            });
        }
    }


    onPreviousBetsResponse(data: Comm.ResponseTypes.PreviousBets)
    {
        if (this.state.menuIndex == 0 && this.state.previous)
        {
            this.setState({
                data: data.previous_round_bets,
                bet_count: data.previous_round_total_bet_count,
                previousMultiplier: data.previous_round_crashpoint,
                ...this.getBetsListHeightAndPad(data.previous_round_bets)
            });
        }
    }


    clickPrevious()
    {
        const previous = !this.state.previous;

        const data = previous ? null : Controller.all_bets;
        this.setState({
            previous: previous,
            data: data,
            bet_count: Controller.all_bets_count,
            ...this.getBetsListHeightAndPad(data)
        });

        if (previous)
        {
            Comm.send(Comm.REQUEST.PREVIOUS_BETS, {});
        }
    }


    clickFair()
    {
        app.addWindow(<ProvablyFair />);
    }


    clickMenu(index: number)
    {
        this.setState({
            menuIndex: index,
            winsIndex: 0,
            timeIndex: 0,
            previous: false,
            data: [
                Controller.all_bets,
                Controller.my_bets,
                null
            ][index],
            ...this.getBetsListHeightAndPad(Controller.all_bets)
        });

        if (index == 2)
        {
            Comm.send(Comm.REQUEST.LEADERBOARD, {
                type: this.leaderboardTypesMap[0],
                period: this.leaderboardPeriodsMap[0]
            });
        }
    }


    clickTopMenu(index: number)
    {
        this.setState({
            winsIndex: index,
            data: null
        });

        Comm.send(Comm.REQUEST.LEADERBOARD, {
            type: this.leaderboardTypesMap[index],
            period: this.leaderboardPeriodsMap[this.state.timeIndex]
        });
    }


    clickTimeMenu(index: number)
    {
        this.setState({
            timeIndex: index,
            data: null
        });

        Comm.send(Comm.REQUEST.LEADERBOARD, {
            type: this.leaderboardTypesMap[this.state.winsIndex],
            period: this.leaderboardPeriodsMap[index]
        });
    }


    clickShare(data: Comm.ResponseTypes.BetData)
    {
        notifications.message(lang.shared["ui-components"].toastr["toastr-message"]["copied-for-chat"]);
        copyToClipboard("/share_bet:" + data.bet_id + " ");
        Controller.setBetCopy(data);
    }


    _renderButtons(share: boolean = true, fair: boolean = true, data: Comm.ResponseTypes.BetData)
    {
        
        <div className="cell3">
            <div
                className="icon_share"
                onClick={this.clickShare.bind(this, data)}
            >
                
            </div>
            <div
                className={[
                    "icon_fair", 
                    data.game_round_id.toString() == Controller.gameRoundId && "disabled"
                ].filter(Boolean).join(" ")}
                onClick={this.checkFairness.bind(this, data.game_round_id.toString())}
            >
                
            </div>
        </div>
    }


    render()
    {
        return (
            <div
                id="bets"
            >

                <div
                    className="menu"
                >
                    {this.renderMainSwitcher()}

                    <div
                        className={"wrapper " + (this.state.previous ? "previous" : "")}
                    >
                        <div className="content">
                            {this.renderMenu()}
                        </div>

                        {this.renderFooter()}
                    </div>
                </div>

            </div>
        );
    }


    renderMenu()
    {
        switch (this.state.menuIndex)
        {
            case 0:
                return this.renderAllBets();

            case 1:
                return this.renderMyBets();

            case 2:
                return this.renderTopBets();
        }
    }


    renderMainSwitcher()
    {
        const lang = window.lang.game["bets-widget"];

        return (
            <div
                className="switcher_holder font_low"
            >
                <div
                    className="switcher"
                >
                    <div
                        className="switch highlighter"
                        style={{
                            transform: "translate(" + this.state.menuIndex * 100 + "px, 0)"
                        }}
                    ></div>
                    <div
                        className={"switch " + (this.state.menuIndex == 0 ? "selected" : "")}
                        onClick={this.clickMenu.bind(this, 0)}
                    >
                        {lang["All Bets"]}
                    </div>
                    <div
                        className={"switch " + (this.state.menuIndex == 1 ? "selected" : "")}
                        onClick={this.clickMenu.bind(this, 1)}
                    >
                        {lang["My Bets"]}
                    </div>
                    <div
                        className={"switch " + (this.state.menuIndex == 2 ? "selected" : "")}
                        onClick={this.clickMenu.bind(this, 2)}
                    >
                        {lang["Top"]}
                    </div>
                </div>
            </div>
        );
    }


    renderAllBets()
    {

        const lang = window.lang.game["bets-widget"];
        const lShared = window.lang.shared;
        
        return (
            <div
                id="menu_all_bets"
                className={this.state.previous ? "previous" : ""}
            >
                <div
                    className="row info_head"
                >
                    <div
                        className="texts"
                    >
                        <div
                            className="title font_upper"
                        >
                            {lang["All Bets"]}
                        </div>
                        <div
                            className="value"
                        >
                            {this.state.bet_count}
                        </div>
                    </div>

                    <div className="last_multiplier">
                        {Common.renderMultiplier(this.state.previousMultiplier, "-")}
                    </div>

                    <div
                        className="button primary font_low button_previous"
                        onClick={this.clickPrevious.bind(this)}
                    >
                        <div className="icon_history"></div>
                        <div className="label">
                            {lang["previous hand"]}
                        </div>
                    </div>
                </div>

                <div
                    className="row font_low table_head"
                >
                    <div className="cell1">
                        {lang["user"]}
                    </div>
                    <div className="cell2">
                        {lShared["bet"]} {currency}
                    </div>
                    <div className="cell3">
                        X
                    </div>
                    <div className="cell4">
                        {lShared["cash_out"]} {currency}
                    </div>
                </div>

                <div
                    className="list scroll-y"
                    ref={this.refList}
                    onScroll={this.updateBetsListHeightAndPad.bind(this)}
                >
                    <div
                        className="scroll_wrapper"
                        style={{
                            paddingTop: (this.state.itemsPad * 36) + "px",
                            paddingBottom: (((this.state.data?.length || 0) - this.state.itemsShown - this.state.itemsPad) * 36) + "px"
                        }}
                    >
                        {this.renderAllBetsList()}
                    </div>
                </div>
            </div>
        );
    }


    getBetsListHeightAndPad(data?: Array<Comm.ResponseTypes.BetData>)
    {
        if (!data)
        {
            data = this.state.data
        }

        const list = this.refList.current;

        if (!list)
        {
            return {
                itemsPad: 0,
                itemsShown: 0
            };
        }

        const length = data?.length || 0;

        const visible = Math.ceil(list.clientHeight / 36);
        const shown = Math.min(visible * 3, length);
        let pad = this.state.itemsPad;

        const down = ((pad + shown) * 36) - (this.refList.current.clientHeight + this.refList.current.scrollTop);
        const up = this.refList.current.scrollTop - pad * 36;

        if (down < 0)
        {
            pad = Math.floor(list.scrollTop / 36);
        }
        else if (up < 0)
        {
            pad = Math.floor(list.scrollTop / 36) - shown + visible + 1;
        }

        pad = Math.max(Math.min(pad, length - shown), 0);

        return {
            itemsPad: pad,
            itemsShown: shown
        };
    }

    timeout: any = null;
    updateBetsListHeightAndPad()
    {
        if (this.state.menuIndex != 0)
        {
            return;
        }

        const {itemsShown, itemsPad} = this.getBetsListHeightAndPad();

        if (this.state.itemsShown !== itemsShown || this.state.itemsPad !== itemsPad)
        {
            this.setState({
                itemsPad,
                itemsShown
            });
        }
    }


    renderAllBetsList()
    {
        if (!this.state.data)
        {
            return (
                <div className="loader">

                </div>
            );
        }

        const arr = [] as Array<JSX.Element>;

        for (let i = 0; i < this.state.itemsShown; i++)
        {
            const data = this.state.data[i + this.state.itemsPad];
            arr.push(
                <div
                    className={"item " + ((Number(data.win_amount) >= Number(data.bet_amount)) ? "cashouted" : "")}
                    key={this.state.itemsPad + i}
                >
                    <div className="cell1">
                        <img
                            className="avatar"
                            src={"gfx/avatars/av-" + data.player_avatar + ".png?version=" + version}
                        />
                        <div
                            className="user"
                        >
                            {data.username}
                        </div>
                    </div>
                    <div className="cell2">
                        {this.renderBet(data)}
                    </div>
                    <div className="cell3">
                        {Number(data.multiplier) !== 0 ? (
                            Common.renderMultiplier(data.multiplier, "-")
                        ) : (
                            ""
                        )}
                    </div>
                    <div className="cell4">
                        {(this.state.previous || Number(data.win_amount) > 0) && (
                            <div className="money">
                                <div>
                                    {Common.renderValue(data.win_amount)}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return arr;
    }


    renderBet(data: Comm.ResponseTypes.BetData)
    {
        const lang = window.lang.game["bets-widget"];

        if (Number(data.bet_amount) == 0)
        {
            return <div className="freeBet">
                FREE BET
            </div>
        }
        else
        {
            return Common.renderCurrency(data.bet_amount, data.currency, "-");
        }

    }


    renderMyBets()
    {
        const lang = window.lang.game["bets-widget"];
        const lShared = window.lang.shared;

        return (
            <div
                id="menu_my_bets"
            >
                <div
                    className="row font_low table_head"
                >
                    <div className="cell1">
                        {lang["date"]}
                    </div>
                    <div className="cell2">
                        <div className="bet">
                            {lShared["bet"]} {currency}
                        </div>
                        <div className="mult">
                            X
                        </div>
                        <div className="cashout">
                            {lShared["cash_out"]} {currency}
                        </div>
                    </div>
                    <div className="cell3">
                        
                    </div>
                </div>

                <div
                    className="list scroll-y"
                >
                    {this.renderMyBetsList()}
                </div>
            </div>
        )
    }


    renderMyBetsList()
    {
        if (!this.state.data)
        {
            return (
                <div className="loader">

                </div>
            );
        }

        const arr = [] as Array<JSX.Element>;
        let count = 0;

        this.state.data.some(data =>
        {
            if (!data.multiplier && !data.crashpoint)
            {
                return;
            }
            
            arr.push(
                <div
                    className={"item " + (Number(data.win_amount) >= Number(data.bet_amount) ? "cashouted" : "")}
                    key={data.bet_id}
                >
                    <div className="date">
                        {Common.parseDate(data.timestamp, "time", true)}
                    </div>
                    <div className="cell2">
                        <div className="bet">
                            {Common.renderCurrency(data.bet_amount, data.currency)}
                        </div>
                        <div className="mult">
                            {Common.renderMultiplier(Number(data.multiplier) ? data.multiplier : data.crashpoint)}
                        </div>
                        <div className="cashout">
                            {Common.renderCurrency(data.win_amount, data.currency, "")}
                        </div>
                    </div>

                    <div className="cell3 buttons">
                        <div
                            className={[
                                "icon_fair", 
                                data.game_round_id.toString() == Controller.gameRoundId && "disabled"
                            ].filter(Boolean).join(" ")}
                            onClick={this.checkFairness.bind(this, data.game_round_id.toString())}
                        ></div>
                        <div
                            className="icon_share"
                            onClick={this.clickShare.bind(this, data)}
                        ></div>
                    </div>
                </div>
            );

            if (++count == 10)
            {
                return true;
            }
        });

        return arr;
    }


    renderTopBets()
    {
        const lang = window.lang.game["bets-widget"].top;

        return (
            <div
                id="menu_top_bets"
            >
                <div className="switcher2 font_upper wins_switch">
                    <div
                        className={"switch " + (this.state.winsIndex == 0 ? "selected" : "")}
                        onClick={this.clickTopMenu.bind(this, 0)}
                    >
                        <div>
                            {lang["huge wins"]}
                        </div>
                    </div>
                    <div
                        className={"switch " + (this.state.winsIndex == 1 ? "selected" : "")}
                        onClick={this.clickTopMenu.bind(this, 1)}
                    >
                        <div>
                            {lang["biggest wins"]}
                        </div>
                    </div>
                    <div
                        className={"switch " + (this.state.winsIndex == 2 ? "selected" : "")}
                        onClick={this.clickTopMenu.bind(this, 2)}
                    >
                        <div>
                            {lang["coefficients"]}
                        </div>
                    </div>
                </div>

                <div
                    className="switcher_holder font_low date_switch"
                >
                    <div
                        className="switcher"
                    >
                        <div
                            className="switch highlighter"
                            style={{
                                transform: "translate(" + this.state.timeIndex * 100 + "px, 0)"
                            }}
                        ></div>
                        <div
                            className={"switch " + (this.state.timeIndex == 0 ? "selected" : "")}
                            onClick={this.clickTimeMenu.bind(this, 0)}
                        >
                            {lang["Day"]}
                        </div>
                        <div
                            className={"switch " + (this.state.timeIndex == 1 ? "selected" : "")}
                            onClick={this.clickTimeMenu.bind(this, 1)}
                        >
                            {lang["Month"]}
                        </div>
                        <div
                            className={"switch " + (this.state.timeIndex == 2 ? "selected" : "")}
                            onClick={this.clickTimeMenu.bind(this, 2)}
                        >
                            {lang["Year"]}
                        </div>
                    </div>
                </div>

                {this.renderTopMenu()}

            </div>
        )
    }


    renderTopMenu()
    {
        const lang = window.lang.game["bets-widget"];

        switch (this.state.winsIndex)
        {
            case 0:
                return (
                    <div className="list scroll-y">
                        {this.renderHugeWinsList()}
                    </div>
                );

            case 1:
                return (
                    <div className="list biggest scroll-y">
                        {this.renderBiggestWinsList()}
                    </div>
                );

            case 2:
                return (
                    <>
                        <div
                            className="row font_low table_head"
                        >
                            <div className="cell1">
                                {lang["date"]}
                            </div>
                            <div className="cell2">
                                X
                            </div>
                            <div className="cell3">
                                {lang["fairness"]}
                            </div>
                        </div>

                        <div className="list multipliers scroll-y">
                            {this.renderMultipliersList()}
                        </div>
                    </>
                );
        }
    }


    renderHugeWinsList()
    {
        if (!this.state.data)
        {
            return (
                <div className="loader">

                </div>
            );
        }

        const arr = [] as Array<JSX.Element>;
        const lang = window.lang.game["bets-widget"];
        const lShared = window.lang.shared;

        this.state.data.forEach(data =>
        {
            arr.push(
                <div 
                    className="item"
                    key={"item_huge_" + data.bet_id}
                >
                    <div className="content">
                        <div className="player">
                            <img
                                className="avatar"
                                src={"gfx/avatars/av-" + data.player_avatar + ".png?version=" + version}
                            />
                            <div className="user">
                                {data.username}
                            </div>
                        </div>

                        <div className="data">
                            <div className="row">
                                <div className="title font_low">
                                    {lShared["bet"]} {currency}:
                                </div>
                                <div className="value">
                                    {Common.renderCurrency(data.bet_amount, data.currency)}
                                </div>
                            </div>

                            <div className="row">
                                <div className="title font_low">
                                    {lShared["cashed_out"]}:
                                </div>
                                <div className="value">
                                    {Common.renderMultiplier(data.multiplier, "-")}
                                </div>
                            </div>

                            <div className="row">
                                <div className="title font_low">
                                    {lShared["win"]} {currency}:
                                </div>
                                <div className="value win">
                                    {Common.renderCurrency(data.win_amount, data.currency, "-")}
                                </div>
                            </div>
                        </div>

                        <div
                            className={"icon_fair"}
                            onClick={this.checkFairness.bind(this, data.game_round_id.toString())}
                        ></div>
                    </div>

                    <div className="footer">
                        <div className="date">
                            {Common.parseDate(data.timestamp ,"date")}
                        </div>

                        <div className="round">
                            <div className="title font_low">
                                {lShared["round"]}:
                            </div>
                            <div className="value win">
                                &nbsp;{data.crashpoint}x
                            </div>
                        </div>

                        <div
                            className="button"
                            onClick={this.clickShare.bind(this, data)}
                        >
                            <div className="icon_share_double"></div>
                        </div>
                    </div>

                </div>
            );
        });

        return arr;
    }


    renderBiggestWinsList()
    {
        if (!this.state.data)
        {
            return (
                <div className="loader">

                </div>
            );
        }

        const arr = [] as Array<JSX.Element>;
        const lang = window.lang.game["bets-widget"];
        const lShared = window.lang.shared;

        this.state.data.forEach(data =>
        {
            arr.push(
                <div 
                    className={"item biggest " + Common.parseMultiplierClassName(data.multiplier)}
                    key={"item_big_" + data.bet_id}
                >
                    <div className="content">
                        <div className="player">
                            <img
                                className="avatar"
                                src={"gfx/avatars/av-" + data.player_avatar + ".png?version=" + version}
                            />
                            <div className="user">
                                {data.username}
                            </div>
                        </div>

                        <div className="data">
                            <div className="row">
                                <div className="title font_low">
                                    {lShared["bet"]} {currency}:
                                </div>
                                <div className="value">
                                    {Common.renderCurrency(data.bet_amount, data.currency)}
                                </div>
                            </div>

                            <div className="row">
                                <div className="title font_low">
                                    {lShared["win"]} {currency}:
                                </div>
                                <div className="value win">
                                    {Common.renderCurrency(data.win_amount, data.currency)}
                                </div>
                            </div>

                            <div className="row">
                                <div className="title font_low">
                                    {lShared["multiplier"]}:
                                </div>
                                <div className="value multiplier">
                                    {Common.renderMultiplier(data.multiplier)}
                                </div>
                            </div>
                        </div>

                        <div
                            className={"icon_fair"}
                            onClick={this.checkFairness.bind(this, data.game_round_id.toString())}
                        ></div>
                    </div>

                    <div className="footer">
                        <div className="date">
                            {Common.parseDate(data.timestamp ,"date")}
                        </div>

                        <div className="round">
                            <div className="title font_low">
                                {lShared["round"]}:
                            </div>
                            <div className="value win">
                                &nbsp;{data.crashpoint}x
                            </div>
                        </div>

                        <div
                            className="button"
                            onClick={this.clickShare.bind(this, data)}
                        >
                            <div className="icon_share_double"></div>
                        </div>
                    </div>

                </div>
            );
        });

        return arr;
    }


    renderMultipliersList()
    {
        if (!this.state.data)
        {
            return (
                <div className="loader">

                </div>
            );
        }

        const arr = [] as Array<JSX.Element>;

        this.state.data.forEach(data =>
        {
            arr.push(
                <div 
                    className="item multipliers"
                    key={"item_mult_" + data.game_round_id}
                >

                    <div className="date">
                        {Common.parseDate(data.timestamp, "date_full", true)}
                    </div>

                    {Common.renderMultiplier(data.crashpoint)}

                    <div className="buttons">
                        <div
                            className={[
                                "icon_fair", 
                                data.game_round_id.toString() == Controller.gameRoundId && "disabled"
                            ].filter(Boolean).join(" ")}
                            onClick={this.checkFairness.bind(this, data.game_round_id.toString())}
                        ></div>
                    </div>
                </div>
            );
        });

        return arr;
    }


    renderFooter()
    {

        const lang = window.lang.shared["ui-components"]["spribe-footer"];

        return (
            <div className="footer">
                <div
                    className="left"
                >
                    <div
                        className="info1"
                    >
                        {lang["this game is"]}
                    </div>
                    <div
                        className="button fair"
                        onClick={this.clickFair.bind(this)}
                    >
                        <div className="icon_fair"></div>
                        <div
                            className="info2"
                        >
                            Provably Fair
                        </div>
                    </div>
                </div>

                <div
                    className="right"
                >
                    <div
                        className="info1"
                    >
                        Powered by
                    </div>
                    <a
                        href="https://spribe.co/"
                        target="_blank"
                    >
                        <div className="icon_spribe"></div>
                    </a>
                </div>
            </div>
        );
    }


}


export namespace Bets
{

    export interface Props
    {

    }

    export interface State
    {
        menuIndex: number;
        winsIndex: number;
        timeIndex: number;
        previous: boolean;
        previousMultiplier: number;

        data: Array<Comm.ResponseTypes.BetData> | null;
        bet_count: number;

        itemsShown: number;
        itemsPad: number;
    }

}